// eslint-disable-next-line
export default new (class ArticleModel {
  // static API_URL = process.env.REACT_APP_API_URL;

  async get(data) {
    const model = {};

    model.id = data.id || 0;
    model.title = data.Title || [];
    model.description = data.description || [];
    model.slug = data.Slug || "";
    model.tag = data.tag || [];

    if (data.content?.length > 0) {
      model.content = data.content;
    } else {
      model.content = [];
    }

    if (
      data.Image?.length > 0 &&
      data.Image[0]?.image
    ) {
      model.image = data.Image[0].image;
    } else {
      model.image = [];
    }

    model.createdAt = data.createdAt || "";
    model.publishedAt = data.publishedAt || "";

    return model;
  }
})();
